import fetch from 'cross-fetch';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { env } from '../../common/__config__/env';

const link = createHttpLink({
  uri: env.PM_GRAPH,
  fetch: fetch,
});

const cache = new InMemoryCache();
if (typeof window !== 'undefined') {
  cache.restore(window.__APOLLO_STATE__);
}

export const client = new ApolloClient({
  name: 'privatmegleren_objektsider_client',
  link: link,
  cache: cache,
  ssrForceFetchDelay: 100,
});
